import Styles from './CustomizeSchedule.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import dayjs from 'dayjs'
import { ArrowCurveRightDown, Calendar2, ChevronDown2 } from 'blaze-ui/icons'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { DateTimePicker } from 'blaze-ui/DateTimePicker/DateTimePicker'
import { useOverlayTriggerState } from '@react-stately/overlays'
import { Button } from 'blaze-ui/Button'
import { ScheduleCard } from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/ScheduleCard'

dayjs.extend(advancedFormat)

interface Props {
  startDate: string
  onStartDateChange: (startDate: string) => void
}

export const StartDateInput = ({ startDate, onStartDateChange }: Props) => {
  const overlayState = useOverlayTriggerState({})
  const nameOfDay = dayjs(startDate).format('dddd')

  return (
    <ScheduleCard>
      <Heading level={3}>When should Blaze start posting content?</Heading>
      <DateTimePicker
        onClose={overlayState.close}
        showTimeControls={false}
        disableDatesAfter={dayjs().add(7, 'days').format('YYYY-MM-DD')}
        dateTime={dayjs(startDate)}
        placement="bottom-start"
        setDateTime={(datetime) => {
          if (datetime) onStartDateChange(datetime.toISOString())
        }}
      >
        <div className={Styles.startDateButton}>
          <Button frontIcon={Calendar2} size="xl" variant="secondary" endIcon={ChevronDown2}>
            {dayjs(startDate).format('dddd, MMMM Do, YYYY')}
          </Button>
        </div>
      </DateTimePicker>
      <div className={Styles.explainer}>
        <div>
          <ArrowCurveRightDown size={20} color="var(--selected-fill)" />
        </div>
        <Text variant="secondary" color="var(--dark-80)">
          New content will post every <b>{nameOfDay}</b>.
        </Text>
      </div>
    </ScheduleCard>
  )
}
